import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import styles from './index.module.scss';
import { makeStyles } from '@material-ui/core';

const useAutoCompeleteStyles = makeStyles({
  root: {
    '& .MuiInput-underline.Mui-focused:after': {
      borderBottom: '2px solid #EC7963'
    },
    '& .MuiInput-underline:after': {
      borderBottom: '2px solid #EC7963'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#EC7963',
    }
  }
})

export default function Tags({ title, optionsData = [], onChange }) {
  return (
    <div className={styles.autocomplete}>
      <Autocomplete
        classes={useAutoCompeleteStyles()}
        options={optionsData}
        noOptionsText={'請清除目前選項後重新選取'}
        getOptionLabel={(option) => option.label}
        onChange={onChange}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label={title}
          />
        )}
      />
    </div>
  );
}
